<template>
  <a
    :href="url"
    target="_blank"
    rel="noopener noreferrer"
    style=" text-decoration: unset; color:unset;"
  >
    <div
      class="p-5 rounded-md hover:bg-gray-100 transition-all flex gap-5 bg-gray-50 mb-5 items-center"
    >
      <div class="h-32 flex gap-5 items-center">
        <img :src="img || '/user.png'" alt class="h-full rounded-md bg-white p-2" />
        <div>
          <div class="font-bold">
            {{ $t('market.customer_name_and_company') }} :
            <span class="mb-1 font-medium">{{ fullName }}</span>
          </div>

          <div class="font-bold">
            {{ $t('account.phone_number') }} :
            <span class="mb-1 font-medium">{{ joinTel }}</span>
          </div>

          <div class="font-bold">
            {{ $t('account.email_address') }} :
            <span class="mb-1 font-medium">{{ joinEmail }}</span>
          </div>
        </div>
      </div>
      <div class="text-right">
        <div>{{ $t('customer.customer_type') }}</div>
        <p class="text-lg">{{ typeString }}</p>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  computed: {
    fullName() {
      const firstNameAndLastName = this.firstName + " " + this.lastName;
      return this.type == "company" ? this.companyName : firstNameAndLastName;
    },
    joinTel() {
      return this.$helper.telToString(this.interTels, this.tels, { separator: ", " }) || "-"
    },
    joinEmail() {
      const filterEmailEmptyString = this.emails.filter(email => email !== "");
      if (filterEmailEmptyString.length > 0) {
        return filterEmailEmptyString.join(", ");
      } else {
        return "-";
      }
    },
    typeString() {
      const data = {
        personal: this.$t('customer.type.personal'),
        company: this.$t('customer.type.company')
      };
      return data[this.type] || "-";
    }
  },
  props: {
    url: String,
    img: String,
    firstName: String,
    lastName: String,
    companyName: String,
    tels: {
      type: Array,
      default: () => []
    },
    interTels: {
      type: Array,
      default: () => []
    },
    type: String,
    emails: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style>
</style>